import React__default from 'react';

/**
 * Render the label in the month caption.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function CaptionLabel(props) {
    return React__default.createElement("span", { ...props });
}

export { CaptionLabel };
